import { CloseIcon } from "vega-icons";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { useNotificationCenter } from "../NotificationCenter.context";

type Props = {
  title?: string;
  markAllReadLabel?: string;
  closeLabel?: string;
  className?: string;
};

export const NotificationCenterHeader = ({
  title = m.notificationCenter_title(),
  markAllReadLabel = m.notificationCenter_markAllRead(),
  closeLabel = m.notificationCenter_close(),
  className,
}: Props) => {
  const { unreadCount, markAllRead } = useNotificationCenter();

  return (
    <div
      className={cnTwMerge(
        "shrink-0 flex items-center justify-between gap-4 px-4 py-3 border-b-1 border-border/primary bg-background/card",
        className,
      )}
    >
      <DialogPrimitive.Title asChild>
        <h3 className="body-base-semibold text-text/primary">{title}</h3>
      </DialogPrimitive.Title>
      <div className="flex items-center gap-3">
        {unreadCount > 0 ? (
          <ThemedButton
            className="text-text/interactive hover:underline focus-visible:underline"
            dataTestId="notification-center-mark-all-read"
            onClick={() => markAllRead()}
            size="small"
            variant="text"
          >
            {markAllReadLabel}
          </ThemedButton>
        ) : null}
        <DialogPrimitive.Close asChild>
          <ThemedIconButton
            ariaLabel={closeLabel}
            className="sm:hidden"
            dataTestId="notification-center-close"
            icon={<CloseIcon className="h-4 w-4" />}
            size="small"
            variant="noBackground"
          />
        </DialogPrimitive.Close>
      </div>
    </div>
  );
};
